import classNames from "classnames";
import React, { useCallback } from "react";
import { encounterTypeIdx } from "../../../hooks/path-hooks";

const EncounterType = (props) => {
  let { page, options, selectedVal, onFilterChange, disabled } = props;

  if (disabled) return null;

  // Can't change 'mythic' value from path hook (would break data fetching) so it needs to be corrected
  // here to route Mythic+ correct pages (no 'mythic+' at end of url)
  if (selectedVal === "mythic" || selectedVal === "mythic+") {
    selectedVal = "";
  }
  const displayEncounterTypes = useCallback(() => {
    return (options ?? []).map((val, i) => {
      const { type, label } = val;
      const selected = type === selectedVal;
      return (
        <div
          key={i}
          className={classNames("encounter-type-filter", {
            active: selected,
          })}
          onClick={() => {
            if (page === "builds") {
              onFilterChange("encounterType", type, false, encounterTypeIdx);
            } else {
              // this is a tier list page. Right now page is null
              onFilterChange(type);
            }
          }}
        >
          {label}
        </div>
      );
    });
  }, [selectedVal, page, onFilterChange]);

  return <div className="encounter-type-container">{displayEncounterTypes()}</div>;
};

export default EncounterType;
